import { render, staticRenderFns } from "./RestaurantOwnerValidation.vue?vue&type=template&id=634cf356&scoped=true&"
import script from "./RestaurantOwnerValidation.vue?vue&type=script&lang=js&"
export * from "./RestaurantOwnerValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cf356",
  null
  
)

export default component.exports